module.exports = __webpack_public_path__ + "img/volume_down.84e417c9.svg";